<template>
    <div id="webpage">
        <!-- Page Title Start -->
        <div class="ct-form-box">
          <div class="form-title">
            <h6>
              {{ typeof form_label[citation_style]['title'] !== 'undefined' ? form_label[citation_style]['title'] : 'Article Title' }}
              <small v-if="$i18n.locale!=='en'">Page Title</small>
            </h6>

            <button type="button" class="ct-help-box" v-on:click="showHelpMessage('page-title')">
                    <span class="ct-tip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                      <path fill="#0c68f8" d="M6304.806 2008.056a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm.425 9.021a.7.7 0 0 1-.449.151.71.71 0 0 1-.458-.151.75.75 0 0 1 0-1 .724.724 0 0 1 .458-.147.711.711 0 0 1 .449.147.749.749 0 0 1 0 1zm1.462-3.945a1.545 1.545 0 0 1-.336.475 6.453 6.453 0 0 1-.533.462 3.483 3.483 0 0 0-.4.344.837.837 0 0 0-.185.282 1 1 0 0 0-.05.34v.21h-.9v-.277a1.484 1.484 0 0 1 .164-.731 2.212 2.212 0 0 1 .584-.622 3.728 3.728 0 0 0 .593-.529.8.8 0 0 0 .172-.521.573.573 0 0 0-.223-.487 1.035 1.035 0 0 0-.634-.168 2.275 2.275 0 0 0-.706.109 4.853 4.853 0 0 0-.672.277l-.378-.79a4.134 4.134 0 0 1 .84-.34 3.62 3.62 0 0 1 1-.13 1.917 1.917 0 0 1 1.31.407 1.358 1.358 0 0 1 .462 1.071 1.516 1.516 0 0 1-.108.618z" transform="translate(-6298.806 -2008.056)"/>
                    </svg></span>
            </button>
          </div>
          <div class="wv-form-box">
            <input v-model="return_data.title" type="text" class="wv-form-control" placeholder="">
            <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
            </svg>
          </div>
        </div>
        <!-- Article Title End -->

        <!-- Website Name Start -->
        <div class="ct-form-box" v-if="citation_style === 'apa7' || citation_style === 'mla7' || citation_style === 'mla8' || citation_style === 'chicago17' || citation_style === 'vancouver'">
          <div class="form-title">
            <h6>
              {{ typeof form_label[citation_style]['container-title'] !== 'undefined' ? form_label[citation_style]['container-title'] : 'Website Name' }}
              <small v-if="$i18n.locale!=='en'">Website Name</small>
            </h6>

            <button type="button" class="ct-help-box" v-on:click="showHelpMessage('site-name')">
                      <span class="ct-tip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <path fill="#0c68f8" d="M6304.806 2008.056a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm.425 9.021a.7.7 0 0 1-.449.151.71.71 0 0 1-.458-.151.75.75 0 0 1 0-1 .724.724 0 0 1 .458-.147.711.711 0 0 1 .449.147.749.749 0 0 1 0 1zm1.462-3.945a1.545 1.545 0 0 1-.336.475 6.453 6.453 0 0 1-.533.462 3.483 3.483 0 0 0-.4.344.837.837 0 0 0-.185.282 1 1 0 0 0-.05.34v.21h-.9v-.277a1.484 1.484 0 0 1 .164-.731 2.212 2.212 0 0 1 .584-.622 3.728 3.728 0 0 0 .593-.529.8.8 0 0 0 .172-.521.573.573 0 0 0-.223-.487 1.035 1.035 0 0 0-.634-.168 2.275 2.275 0 0 0-.706.109 4.853 4.853 0 0 0-.672.277l-.378-.79a4.134 4.134 0 0 1 .84-.34 3.62 3.62 0 0 1 1-.13 1.917 1.917 0 0 1 1.31.407 1.358 1.358 0 0 1 .462 1.071 1.516 1.516 0 0 1-.108.618z" transform="translate(-6298.806 -2008.056)"/>
                      </svg></span>
            </button>
          </div>
          <div class="wv-form-box">
            <input v-model="return_data['container-title']" type="text" class="wv-form-control" placeholder="">
            <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
            </svg>
          </div>
        </div>
        <!-- Website Name End -->

        <!-- Publisher Name Start -->
        <div class="ct-form-box" v-if="citation_style === 'mla7' || citation_style === 'mla8'">
          <div class="form-title">
            <h6>
              {{ typeof form_label[citation_style]['publisher'] !== 'undefined' ? form_label[citation_style]['publisher'] : 'Publisher' }}
              <small v-if="$i18n.locale!=='en'">Publisher Name</small>
            </h6>


            <button type="button" class="ct-help-box" v-on:click="showHelpMessage('publisher-name')">
                        <span class="ct-tip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                          <path fill="#0c68f8" d="M6304.806 2008.056a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm.425 9.021a.7.7 0 0 1-.449.151.71.71 0 0 1-.458-.151.75.75 0 0 1 0-1 .724.724 0 0 1 .458-.147.711.711 0 0 1 .449.147.749.749 0 0 1 0 1zm1.462-3.945a1.545 1.545 0 0 1-.336.475 6.453 6.453 0 0 1-.533.462 3.483 3.483 0 0 0-.4.344.837.837 0 0 0-.185.282 1 1 0 0 0-.05.34v.21h-.9v-.277a1.484 1.484 0 0 1 .164-.731 2.212 2.212 0 0 1 .584-.622 3.728 3.728 0 0 0 .593-.529.8.8 0 0 0 .172-.521.573.573 0 0 0-.223-.487 1.035 1.035 0 0 0-.634-.168 2.275 2.275 0 0 0-.706.109 4.853 4.853 0 0 0-.672.277l-.378-.79a4.134 4.134 0 0 1 .84-.34 3.62 3.62 0 0 1 1-.13 1.917 1.917 0 0 1 1.31.407 1.358 1.358 0 0 1 .462 1.071 1.516 1.516 0 0 1-.108.618z" transform="translate(-6298.806 -2008.056)"/>
                        </svg></span>
            </button>
          </div>
          <div class="wv-form-box">
            <input v-model="return_data.publisher" type="text" class="wv-form-control" placeholder="">
            <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
            </svg>
          </div>
        </div>
        <!-- Publisher Name End -->

        <!-- URL Start -->
        <div class="ct-form-box" v-if="citation_style !== 'mla7'">
          <div class="form-title">
            <h6>{{ typeof form_label[citation_style]['URL'] !== 'undefined' ? form_label[citation_style]['URL'] : 'URL' }}</h6>

            <button type="button" class="ct-help-box" v-on:click="showHelpMessage('url')">
                          <span class="ct-tip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                            <path fill="#0c68f8" d="M6304.806 2008.056a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm.425 9.021a.7.7 0 0 1-.449.151.71.71 0 0 1-.458-.151.75.75 0 0 1 0-1 .724.724 0 0 1 .458-.147.711.711 0 0 1 .449.147.749.749 0 0 1 0 1zm1.462-3.945a1.545 1.545 0 0 1-.336.475 6.453 6.453 0 0 1-.533.462 3.483 3.483 0 0 0-.4.344.837.837 0 0 0-.185.282 1 1 0 0 0-.05.34v.21h-.9v-.277a1.484 1.484 0 0 1 .164-.731 2.212 2.212 0 0 1 .584-.622 3.728 3.728 0 0 0 .593-.529.8.8 0 0 0 .172-.521.573.573 0 0 0-.223-.487 1.035 1.035 0 0 0-.634-.168 2.275 2.275 0 0 0-.706.109 4.853 4.853 0 0 0-.672.277l-.378-.79a4.134 4.134 0 0 1 .84-.34 3.62 3.62 0 0 1 1-.13 1.917 1.917 0 0 1 1.31.407 1.358 1.358 0 0 1 .462 1.071 1.516 1.516 0 0 1-.108.618z" transform="translate(-6298.806 -2008.056)"/>
                          </svg></span>
            </button>
          </div>
          <div class="wv-form-box">
            <input type="text" class="wv-form-control" v-model="return_data.URL" placeholder="ex) https://example.com/">
            <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
            </svg>
          </div>
        </div>
        <!-- URL End -->

        <!-- Date Published Start -->
        <div class="ct-form-box">
          <div class="form-title">
            <h6>
              {{ typeof form_label[citation_style]['issued'] !== 'undefined' ? form_label[citation_style]['issued'] : 'Date Published' }}
              <small v-if="$i18n.locale!=='en'">Date Published</small>
            </h6>

            <button type="button" class="ct-help-box" v-on:click="showHelpMessage('date-published')">
                  <span class="ct-tip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                    <path fill="#0c68f8" d="M6304.806 2008.056a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm.425 9.021a.7.7 0 0 1-.449.151.71.71 0 0 1-.458-.151.75.75 0 0 1 0-1 .724.724 0 0 1 .458-.147.711.711 0 0 1 .449.147.749.749 0 0 1 0 1zm1.462-3.945a1.545 1.545 0 0 1-.336.475 6.453 6.453 0 0 1-.533.462 3.483 3.483 0 0 0-.4.344.837.837 0 0 0-.185.282 1 1 0 0 0-.05.34v.21h-.9v-.277a1.484 1.484 0 0 1 .164-.731 2.212 2.212 0 0 1 .584-.622 3.728 3.728 0 0 0 .593-.529.8.8 0 0 0 .172-.521.573.573 0 0 0-.223-.487 1.035 1.035 0 0 0-.634-.168 2.275 2.275 0 0 0-.706.109 4.853 4.853 0 0 0-.672.277l-.378-.79a4.134 4.134 0 0 1 .84-.34 3.62 3.62 0 0 1 1-.13 1.917 1.917 0 0 1 1.31.407 1.358 1.358 0 0 1 .462 1.071 1.516 1.516 0 0 1-.108.618z" transform="translate(-6298.806 -2008.056)"/>
                  </svg></span>
            </button>
          </div>

          <div class="ct-form">
            <ul class="wv-row wv-row-cols-md-3">
              <li class="wv-col wv-col-4">
                <div class="wv-form-box">
                  <label class="wv-form-label wv-txt-caption1" for="day">
                    <small>{{ $t('Day') }}</small>
                  </label>
                  <input type="number" class="wv-form-control" id="day" placeholder="dd"
                         v-model="return_data.issued['date-parts'][0][2]"
                         maxlength="2"
                         oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                  <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
                  </svg>
                </div>
              </li>
              <li class="wv-col wv-col-4">
                <div class="wv-form-box">
                  <label class="wv-form-label wv-txt-caption1" for="month">
                    <small>{{ $t('Month') }}</small>
                  </label>
                  <input type="number" class="wv-form-control" id="month" placeholder="mm"
                         v-model="return_data.issued['date-parts'][0][1]"
                         maxlength="2"
                         oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                  <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
                  </svg>
                </div>
              </li>
              <li class="wv-col wv-col-4">
                <div class="wv-form-box">
                  <label class="wv-form-label wv-txt-caption1" for="year">
                    <small>{{ $t('Year') }}</small>
                  </label>
                  <input type="number" class="wv-form-control" id="year" placeholder="yyyy"
                         v-model="return_data.issued['date-parts'][0][0]"
                         maxlength="4"
                         oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  >
                  <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
                  </svg>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- Date Published End -->

        <!-- Date Accessed Start -->
        <div class="ct-form-box" v-if="citation_style === 'apa6' || citation_style === 'mla7' || citation_style === 'vancouver' ">
          <div class="form-title">
            <h6>
              {{ typeof form_label[citation_style]['accessed'] !== 'undefined' ? form_label[citation_style]['accessed'] : 'Date Accessed' }}
              <small v-if="$i18n.locale!=='en'">Date Accessed</small>
            </h6>

            <button type="button" class="ct-help-box" v-on:click="showHelpMessage('date-accessed')">
                    <span class="ct-tip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                      <path fill="#0c68f8" d="M6304.806 2008.056a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm.425 9.021a.7.7 0 0 1-.449.151.71.71 0 0 1-.458-.151.75.75 0 0 1 0-1 .724.724 0 0 1 .458-.147.711.711 0 0 1 .449.147.749.749 0 0 1 0 1zm1.462-3.945a1.545 1.545 0 0 1-.336.475 6.453 6.453 0 0 1-.533.462 3.483 3.483 0 0 0-.4.344.837.837 0 0 0-.185.282 1 1 0 0 0-.05.34v.21h-.9v-.277a1.484 1.484 0 0 1 .164-.731 2.212 2.212 0 0 1 .584-.622 3.728 3.728 0 0 0 .593-.529.8.8 0 0 0 .172-.521.573.573 0 0 0-.223-.487 1.035 1.035 0 0 0-.634-.168 2.275 2.275 0 0 0-.706.109 4.853 4.853 0 0 0-.672.277l-.378-.79a4.134 4.134 0 0 1 .84-.34 3.62 3.62 0 0 1 1-.13 1.917 1.917 0 0 1 1.31.407 1.358 1.358 0 0 1 .462 1.071 1.516 1.516 0 0 1-.108.618z" transform="translate(-6298.806 -2008.056)"/>
                    </svg></span>
            </button>
          </div>

          <div class="ct-form">
            <ul class="wv-row wv-row-cols-md-3">
              <li class="wv-col wv-col-4">
                <div class="wv-form-box">
                  <label class="wv-form-label wv-txt-caption1" for="accessed_day">
                    <small>{{ $t('Day') }}</small>
                  </label>
                  <input type="number" class="wv-form-control" id="accessed_day" placeholder="dd"
                         v-model="return_data.accessed['date-parts'][0][2]"
                         maxlength="2"
                         oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                  <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
                  </svg>
                </div>
              </li>
              <li class="wv-col wv-col-4">
                <div class="wv-form-box">
                  <label class="wv-form-label wv-txt-caption1" for="accessed_month">
                    <small>{{ $t('Month') }}</small>
                  </label>
                  <input type="number" class="wv-form-control" id="accessed_month" placeholder="mm"
                         v-model="return_data.accessed['date-parts'][0][1]"
                         maxlength="2"
                         oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                  <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
                  </svg>
                </div>
              </li>
              <li class="wv-col wv-col-4">
                <div class="wv-form-box">
                  <label class="wv-form-label wv-txt-caption1" for="accessed_year">
                    <small>{{ $t('Year') }}</small>
                  </label>
                  <input type="number" class="wv-form-control" id="accessed_year" placeholder="yyyy"
                         v-model="return_data.accessed['date-parts'][0][0]"
                         maxlength="4"
                         oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                  <svg class="wv-form-fail-ic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="#f80003" d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-7.268a1.383 1.383 0 1 0 1.383 1.383A1.385 1.385 0 0 0 10 12.732zM9.191 5a.415.415 0 0 0-.414.437L9 11.325a.414.414 0 0 0 .414.395h1.148a.414.414 0 0 0 .414-.395l.246-5.889A.415.415 0 0 0 10.809 5z"></path>
                  </svg>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- Date Accessed End -->
    </div>
</template>

<script>
    import cloneDeep from 'lodash/cloneDeep';
    import Swal from "sweetalert2";

    export default {
        name: "FormWebpage.vue",
        props: [
            'citationStyle'
        ],
        data: function () {
            return {
                form_label: { // 다른 Label 지정하는거 아니면 굳이 데이터 넣을 필요는 없음.
                    apa6: {
                        'title': this.$t('Page Name'),
                        'container-title' : this.$t('Site Name'),
                        'issued' : this.$t('Date Published'),
                        'accessed' : this.$t('Date Accessed'),
                    },
                    apa7: {
                        'title': this.$t('Page Name'),
                        'container-title' : this.$t('Site Name'),
                        'issued' : this.$t('Date Published'),
                        'accessed' : this.$t('Date Accessed'),
                    },
                    mla7: { // [last name], [first name]. "[article title]." [website name]. [publisher], [published date] Web. [accessed date]
                        'title': this.$t('Page Name'),
                        'container-title' : this.$t('Site Name'),
                        'issued' : this.$t('Date Published'),
                        'accessed' : this.$t('Date Accessed'),
                        'publisher' : this.$t('Publisher Name'),
                    },
                    mla8: {
                        'title': this.$t('Page Name'),
                        'container-title' : this.$t('Site Name'),
                        'issued' : this.$t('Date Published'),
                        'accessed' : this.$t('Date Accessed'),
                        'publisher' : this.$t('Publisher Name'),
                    },
                    'chicago16-author-date': {

                    },
                    'chicago17': {
                        'title': this.$t('Page Name'),
                        'container-title' : this.$t('Site Name'),
                        'issued' : this.$t('Date Published'),
                    },
                    'vancouver': {
                        'title': this.$t('Page Name'),
                        'container-title' : this.$t('Site Name'),
                        'issued' : this.$t('Date Published'),
                        'accessed' : this.$t('Date Accessed'),
                    },
                },
                return_data: {
                    'container-title' : '',
                    'title' : '',
                    'URL' : '',
                    'publisher' : '',
                    'issued' : {
                        'date-parts' : [['', '', '']],
                    },
                    'accessed' : {
                        'date-parts' : [['', '', '']],
                    },
                },
                empty_data: {},
                save_data: [],
                citation_style: this.citationStyle
            }
        },
        watch: {
            citationStyle: function (val) {
                // 데이터 임시 저장
                this.save_data[this.citation_style] = cloneDeep(this.return_data);

                this.citation_style = val; // 감지

                // 저장된 값이 있다면 불러온다.
                if (typeof this.save_data[val] !== 'undefined')
                    this.return_data = cloneDeep(this.save_data[val]);
                else
                    this.resetForm();

                // 강제 추가 값
                if( val === 'mla7' )
                    this.return_data.URL = 'blank';
            },
            return_data: {
                deep: true,
                handler() {
                    this.$emit('input', this.return_data); // 변경 신호
                }
            }
        },
        methods: {
            resetForm() {
                // this.return_data = Object.assign({}, this.empty_data);
                this.return_data = cloneDeep(this.empty_data);
            },

            showHelpMessage (idx) {
                this.$parent.showHelpMessage(idx);
            }
        },
        mounted() {
            this.empty_data = cloneDeep(this.return_data);
            // this.empty_data = Object.assign({}, this.return_data);

            if( this.citationStyle === 'mla7' )
                this.return_data.URL = 'blank';
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FormWebpage.vue